<script setup>
import ActionButton from "@js/components/ActionButton.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const loginApikomUrl = computed(() => {
  return (
    "/" +
    props.row.original.id +
    "/login?token=" +
    props.row.original.superAdminDatakeplerLoginToken
  );
});

const loginCustomerUrl = computed(() => {
  if (props.row.original.superAdminDatakeplerLoginToken) {
    return (
      "/" +
      props.row.original.id +
      "/login?token=" +
      props.row.original.adminLoginToken
    );
  }

  return (
    "/" +
    props.row.original.id +
    "/login?token=" +
    props.row.original.adminLoginToken +
    "&asCustomer=1"
  );
});
</script>

<template>
  <div class="flex h-full flex-col items-center justify-center gap-2 p-2">
    <ActionButton
      v-if="props.row.original.superAdminDatakeplerLoginToken"
      size="small"
      :href="loginApikomUrl"
      target="_blank"
      class="w-full"
    >
      {{ t("all.button.loginApikom") }}
    </ActionButton>

    <ActionButton
      size="small"
      color="secondary"
      :href="loginCustomerUrl"
      target="_blank"
      class="w-full"
      :disabled="!props.row.original.adminLoginToken"
    >
      {{ t("all.button.loginCustomer") }}
    </ActionButton>
  </div>
</template>
